(ns minorodata.components.warehouse-credentials.core
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.connections.forms.generator :as gen]
   [minorodata.components.forms.inputs :as inputs]
   [mold-forms.core :as form-component]
   [mold-forms.model :refer [->form-model]]
   [re-posh.core :as re-posh]
   [ui.button :refer [button]]
   [ui.fields :as fields]
   [ui.typography :as typography]
   [ui.alert :as alert]))


(defn update-user-credentials [user-id credentials]
  (dispatch [:users.api/update-warehouse-credentials
             {:user-id     user-id
              :credentials credentials}]))

(defn update-user-credentials-form [user-id f]
  (let [credentials (form-component/model->fields f)
        auth        (:authentication credentials)
        credentials (dissoc credentials :authentication)]
    (update-user-credentials user-id (cond-> credentials
                                       (= auth "basic") (dissoc :private-key :passphrase)
                                       (= auth "key-pair") (dissoc :password)))))


(defn update-role-credentials [role-id credentials]
  (dispatch [:users.api/update-role-warehouse-credentials
             {:role-id     role-id
              :credentials credentials}]))

(defn update-role-credentials-form [role-id f]
  (let [credentials (form-component/model->fields f)
        auth        (:authentication credentials)
        credentials (dissoc credentials :authentication)]
    (update-role-credentials role-id (cond-> credentials
                                       (= auth "basic") (dissoc :private-key :passphrase)
                                       (= auth "key-pair") (dissoc :password)))))

(defn form-render
  [{:keys [form-id on-submit errors role user password bigquery-json enforce-credentials user-id role-id warehouse-type authentication private-key passphrase has-credentials? remove-credentials]}]
  [:form {:on-submit on-submit}
   (when enforce-credentials
     [:div {:class "my-2"}
      [fields/switch
       {:field  enforce-credentials
        :errors errors
        :color  "primary"
        :id     :enforce-credentials
        :label  "Enforce personal Warehouse credentials"}]])

   [:div
    (if (= warehouse-type "bigquery")
      ^{:key bigquery-json}
      [inputs/file-input
       {:field  bigquery-json
        :id     :bigquery-json
        :errors errors}]

      [:div {:class "flex flex-col gap-2"}
       (when (= warehouse-type "snowflake")
         [fields/input
          {:field    role
           :errors   errors
           :id       :role
           :required true
           :label    "Database role"}])

       [fields/input
        {:field    user
         :errors   errors
         :id       :user
         :required true
         :label    "Database user"}]

       (when authentication
         [fields/select
          {:field  authentication
           :errors errors
           :id     :authentication
           :native false
           :label  "Authentication method"
           :options [{:text "Basic Auth" :value "basic"}
                     {:text "Key Pair" :value "key-pair"}]}])

       (when (= (:value authentication) "key-pair")
         [:<>
          [alert/alert {:title "Warning"}
           "Using key pair authentication will remove database password from warehouse configuration."]
          [fields/input
           {:field  private-key
            :errors errors
            :textarea true
            :required true
            :id     :private-key
            :label  "Private key"}]
          [fields/input
           {:field  passphrase
            :errors errors
            :id     :password
            :type   "password"
            :label  "Private key passphrase"}]
          [gen/generate-keypair {:form-id form-id}]])

       (when (not= (:value authentication) "key-pair")
         [fields/input
          {:field    password
           :errors   errors
           :id       :password
           :type     "password"
           :required true
           :label    "Database password"}])])]

   [:div {:class "my-4"}
    [gen/warehouse-status {:user-id user-id
                           :role-id role-id}]]

   [:div {:class "flex gap-2 justify-end"}
    (when has-credentials?
      [button {:on-click remove-credentials
               :variant :error}
       "Remove credentials"])
    [button {:type "submit"}
     "Save"]]])


(defn warehouse-credentials-form-role
  [{:keys [role-id credentials]}]
  (let [{warehouse-type :warehouse-data/sink-type} @(re-posh/subscribe [:warehouse-data/pull])
        redshift?  (= warehouse-type "redshift")
        snowflake? (= warehouse-type "snowflake")
        bigquery?  (= warehouse-type "bigquery")

        creds (:role-warehouse-credentials/credentials credentials)
        {:keys [role user password private-key passphrase bigquery-json]} creds]
    [form-component/form
     (->form-model
      {:id        :role-warehouse-credentials
       :on-submit #(update-role-credentials-form role-id %)
       :clean-up  #(dispatch [:form-model/delete [:form-model/id :user-warehouse-credentials]])
       :fields    (cond->> []
                    (or redshift? snowflake?)
                    (concat [{:name :user :value (or user "") :process (fn [e] (-> e .-target .-value))}
                             {:name :password :value (or password "") :process (fn [e] (-> e .-target .-value))}])
                    snowflake?
                    (concat [{:name :role :value (or role "") :process (fn [e] (-> e .-target .-value))}
                             {:name :authentication :value (if private-key "key-pair" "basic") :process identity}
                             {:name :private-key :value (or private-key "") :process (fn [e] (-> e .-target .-value))}
                             {:name :passphrase :value (or passphrase "") :process (fn [e] (-> e .-target .-value))}])

                    bigquery?
                    (concat [{:name :bigquery-json :value bigquery-json :process identity}]))})
     (fn [fields errors on-submit]
       [form-render
        {:form-id             :role-warehouse-credentials
         :on-submit           on-submit
         :role-id             role-id
         :errors              errors
         :role                (:role fields)
         :user                (:user fields)
         :password            (:password fields)
         :bigquery-json       (:bigquery-json fields)
         :authentication      (:authentication fields)
         :private-key         (:private-key fields)

         :passphrase          (:passphrase fields)
         :warehouse-type      warehouse-type
         :fields              fields
         :enforce-credentials (:enforce-credentials fields)
         :has-credentials?    (not-empty creds)
         :remove-credentials  #(update-role-credentials role-id {:user ""
                                                                 :password ""
                                                                 :role ""})}])]))


(defn warehouse-credentials-form-user
  [{:keys [user-id allow-enforcement? credentials]}]
  (let [{warehouse-type :warehouse-data/sink-type} @(re-posh/subscribe [:warehouse-data/pull])
        redshift?           (= warehouse-type "redshift")
        snowflake?          (= warehouse-type "snowflake")
        bigquery?           (= warehouse-type "bigquery")

        credentials (:warehouse-credentials/credentials credentials)
        {:keys [role user password private-key passphrase bigquery-json]} credentials
        enforce-credentials (:warehouse-credentials/enforce-credentials credentials)]
    [form-component/form
     (->form-model
      {:id        :user-warehouse-credentials
       :on-submit #(update-user-credentials-form user-id %)
       :clean-up  #(dispatch [:form-model/delete [:form-model/id :user-warehouse-credentials]])
       :fields    (cond->> []
                    (or redshift? snowflake?)
                    (concat [{:name :user :value (or user "")}
                             {:name :password :value (or password "")}])

                    snowflake?
                    (concat [{:name :role :value (or role "")}
                             {:name :authentication :value (if private-key "key-pair" "basic") :process identity}
                             {:name :private-key :value (or private-key "") :process (fn [e] (-> e .-target .-value))}
                             {:name :passphrase :value (or passphrase "") :process (fn [e] (-> e .-target .-value))}])

                    bigquery?
                    (concat [{:name :bigquery-json :value bigquery-json :process identity}])

                    allow-enforcement?
                    (concat [{:name :enforce-credentials :value (or enforce-credentials false)
                              :process identity}]))})
     (fn [fields errors on-submit]
       [form-render
        {:form-id             :user-warehouse-credentials
         :on-submit           on-submit
         :user-id             user-id
         :errors              errors
         :role                (:role fields)
         :user                (:user fields)
         :password            (:password fields)
         :bigquery-json       (:bigquery-json fields)
         :authentication      (:authentication fields)
         :private-key         (:private-key fields)
         :passphrase          (:passphrase fields)
         :warehouse-type      warehouse-type
         :fields              fields
         :enforce-credentials (:enforce-credentials fields)
         :has-credentials?    (not-empty credentials)
         :remove-credentials  #(update-user-credentials user-id {:user ""
                                                                 :password ""
                                                                 :role ""})}])]))


(defn warehouse-credentials-form [{:keys [user-id role-id]}]
  (cond
    user-id (dispatch [:users.api/fetch-warehouse-credentials {:user-id user-id}])
    role-id (dispatch [:users.api/fetch-role-warehouse-credentials {:role-id role-id}]))

  (fn [{:keys [user-id role-id allow-enforcement?]}]
    (let [{warehouse-type :warehouse-data/sink-type} @(re-posh/subscribe [:warehouse-data/pull])

          event-key (cond
                      user-id :users.api/fetch-warehouse-credentials
                      role-id :users.api/fetch-role-warehouse-credentials)
          loading?  @(re-posh/subscribe [:mold-http/loading? event-key])
          creds     (cond
                      user-id @(re-posh/subscribe [:warehouse-credentials/pull [:warehouse-credentials/user-id user-id]])
                      role-id @(re-posh/subscribe [:role-warehouse-credentials/pull [:role-warehouse-credentials/role-id role-id]]))]
      [:div {:class "max-w-md"}
       (when (and warehouse-type
                  (or creds (not loading?)))
         (cond
           user-id [warehouse-credentials-form-user {:user-id            user-id
                                                     :credentials        creds
                                                     :allow-enforcement? allow-enforcement?}]
           role-id [warehouse-credentials-form-role {:role-id     role-id
                                                     :credentials creds}]))])))


(defn panel []
  (let [{:user/keys [uid]} @(re-posh/subscribe [:user/pull])]
    [:div {:class "inline-block p-2 m-2 w-full max-w-3xl"}
     [:header {:class "max-w-md mb-4"}
      [typography/h2 {:class "mb-2"} "Personal Warehouse Credentials"]
      [typography/p "Access to the Kleene application is restricted until you add your personal warehouse credentials here."]]

     [warehouse-credentials-form {:user-id uid}]]))


(defn main []
  [:div {:class "m-2"}
   [panel]])
